import { Scores } from "model/Scores";
import {
  PointsDistribution,
  getPoints,
} from "model/Match/Set/PointsDistribution";
import { RoundsRound } from "model/Match/Set/Rounds/Track/RoundsRound";
import { RoundsRoundResult } from "model/Match/Set/Rounds/Track/RoundsRoundResult";
import { TrackRound } from "model/Match/Track/TrackRound";
import { Roster, getRosterId, getRosterDriverIds } from "model/Roster/Roster";
import { RosterScope } from "model/Roster/RosterScope";

export const mapRoundsRounds = (
  baseRounds: TrackRound[],
  rosters: Roster[],
  rosterScope: RosterScope,
  runningScores: Scores,
  points: PointsDistribution
) => {
  return baseRounds.map((r) =>
    mapRoundsRound(r, rosters, rosterScope, runningScores, points)
  );
};

const mapRoundsRound = (
  base: TrackRound,
  rosters: Roster[],
  rosterScope: RosterScope,
  runningScores: Scores,
  pointsDist: PointsDistribution
): RoundsRound => {
  const results: RoundsRoundResult[] = [];
  for (let i = 0; i < rosters.length; i++) {
    const roster = rosters[i];
    const rosterId = getRosterId(roster);
    if (!rosterId) {
      continue;
    }

    const rosterDriverIds = getRosterDriverIds(roster, rosterScope) ?? [];
    const pointsAtStart = runningScores[rosterId] ?? 0;
    const rosterTimes = base.times.filter((t) =>
      rosterDriverIds.includes(t.driverId)
    );

    let pointsDelta = 0;
    rosterTimes.forEach((t) => {
      pointsDelta += getPoints(pointsDist, t);
    });

    const runningScore = pointsAtStart + pointsDelta;
    results.push({
      rosterId,
      pointsAtStart,
      pointsDelta,
    });
    runningScores[rosterId] = runningScore;
  }

  return {
    ...base,
    results,
  };
};
